'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _TextInput = require('./TextInput');

var _TextInput2 = _interopRequireDefault(_TextInput);

var _helpersTime = require('../../helpers/time');

var _components = {
	_$TimeInput: {
		displayName: 'TimeInput'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var TimeInput = (function (_Component) {
	_inherits(TimeInput, _Component);

	function TimeInput(props) {
		_classCallCheck(this, _TimeInput);

		_Component.call(this, props);
		var value = undefined;
		if (typeof props.value != 'undefined') {
			value = _helpersTime.time2string(props.value);
		} else {
			value = '';
		}
		this.state = { value: value };
	}

	TimeInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		this.setState({ value: _helpersTime.time2string(nextProps.value) });
	};

	TimeInput.prototype.handleChange = function handleChange(value) {
		this.setState({ value: value });
	};

	TimeInput.prototype.handleBlur = function handleBlur() {
		if (this.props.onChange) {
			this.props.onChange(this.state.value != '' ? _helpersTime.string2time(this.state.value) : null, this);
		}
		if (this.props.onBlur) {
			this.props.onBlur(this.state.value != '' ? _helpersTime.string2time(this.state.value) : null, this);
		}
	};

	TimeInput.prototype.render = function render() {
		var _this = this;

		return _react2['default'].createElement(_TextInput2['default'], _extends({}, this.props, {
			value: this.state.value,
			onChange: function (value) {
				return _this.handleChange(value);
			},
			onBlur: function () {
				return _this.handleBlur();
			}
		}));
	};

	var _TimeInput = TimeInput;
	TimeInput = _wrapComponent('_$TimeInput')(TimeInput) || TimeInput;
	return TimeInput;
})(_Component2['default']);

exports['default'] = TimeInput;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/TimeInput.js
 ** module id = 1044
 ** module chunks = 1
 **/